/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */

import React, { useState } from 'react';

// eslint-disable-next-line object-curly-newline
export function GovBrSelect({ value, setValue, list, label }) {
  const [isOpen, setIsOpen] = useState(false);
  const [filter, setFilter] = useState(null);

  const handleChange = (e) => {
    if (
      !value ||
      list?.filter((e) =>
        e?.toLowerCase().includes(e?.target?.value.toLowerCase()),
      )
    )
      setFilter(e?.target?.value);
  };
  return (
    <div className="br-select">
      <div className="br-input">
        <label htmlFor={`select-${label}`}>{label}</label>
        <input
          onFocus={() => setIsOpen(true)}
          value={filter !== null ? filter : value}
          onChange={handleChange}
          autoComplete="off"
          id={`select-${label}`}
          type="text"
          placeholder="Selecione o item"
        />
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className="br-button"
          type="button"
          aria-label="Exibir lista"
          data-trigger="data-trigger"
        >
          <i
            className={isOpen ? 'fas fa-angle-up' : 'fas fa-angle-down'}
            aria-hidden="true"
          />
        </button>
      </div>
      {isOpen && (
        <div className="br-list" style={{ display: 'block' }}>
          <div className="br-item">
            <div className="br-radio">
              <input
                onClick={() => {
                  setFilter(null);
                  setIsOpen(false);
                  setValue('');
                }}
                id={`clearSelect-${label}`}
                type="radio"
                name={`clearSelect-${label}`}
              />
              <label htmlFor={`clearSelect-${label}`}> {'-'} </label>
            </div>
          </div>
          {list
            ?.sort((a, b) => a?.[0]?.localeCompare(b?.[0]))
            ?.filter((e) => {
              const value = filter
                ? e?.toLowerCase()?.includes(filter?.toLowerCase())
                : true;
              return value;
            })
            ?.map((el, index) => (
              <div className="br-item" key={`orgItem-${index}`}>
                <div className="br-radio">
                  <input
                    onClick={() => {
                      setIsOpen(false);
                      setFilter(null);
                      setValue(el);
                    }}
                    id={`${label}-${index}`}
                    type="radio"
                    name={`${label}-${index}`}
                  />
                  <label htmlFor={`${label}-${index}`}>{el}</label>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
